<template>
  <b-modal :id="newModal.id" v-model="newModal.active" centered :title="$t('affiliates.cpaDetails')"
           :ok-title="$t('operations.add')" size="lg"
           no-close-on-backdrop hide-footer
           @hide="resetInfoModal"
  >
    <b-row>
      <b-col cols="12" lg="4">
        <label>{{ $t('affiliates.costPerAcquisition') }} (CPA)</label>
        <b-form-input v-model="newCpa.cpa" type="number"/>
      </b-col>

      <b-col cols="12" lg="4">
        <label>{{ $t('affiliates.conversionRateGoals') }} (CRG)</label>
        <b-form-input v-model="newCpa.crg" type="number"/>
      </b-col>

      <b-col cols="12" lg="4">
        <label>{{ $t('affiliates.conversionRateGoalsPeriodInWeeks') }}</label>
        <b-form-input v-bind:disabled="editing" v-model="newCpa.crgWeek" type="number"/>
      </b-col>

      <b-col cols="12" lg="6">
        <label>{{ $t('affiliates.startDate') }}</label>
        <calendar-picker v-bind:disabled="editing" v-model="newCpa.startDate"/>
      </b-col>
      <b-col cols="12" lg="6">
        <label>{{ $t('affiliates.endDate') }}</label>
        <calendar-picker v-model="newCpa.endDate"/>
      </b-col>
      <b-col cols="12" lg="6">
        <label>{{ $t('affiliates.lateFTDContract') }}</label>
        <v-select
            v-bind:disabled="editing"
            v-model="newCpa.lateFTDContract"
            v-bind:options="affiliateLateFTDContractOptions"
            :reduce="s=>s.value"
            label="title"
        >
          <template #option="option">
            <div class="">
              <p class="m-0 font-small-2">{{ option.title }}</p>
              <p class="m-0 font-small-1 text-muted">{{ option.description }}</p>
            </div>
          </template>
        </v-select>
      </b-col>
      <b-col cols="12" lg="6">
        <label>{{ $t('affiliates.maxFtdLateDays') }}</label>
        <b-form-input v-bind:disabled="editing || isMaxFtdLateDaysNotRequired" v-model="newCpa.maxFtdLateDays"
                      type="number"
        />
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col cols="6">
        <b-button :disabled="busy" size="sm" block variant="warning" @click="newModal.active=false">
          {{ $t('operations.cancel') }}
        </b-button>
      </b-col>
      <b-col cols="6">
        <b-button
            :disabled="canNotSave || busy"
            size="sm" block variant="primary"
            @click="saveCpa()"
        >{{ editing ? $t('operations.update') : $t('operations.add') }}
        </b-button>
      </b-col>
    </b-row>

  </b-modal>
</template>

<script>
import CalendarPicker from '@/components/widget/picker/calendarPicker.vue'
import { mapActions, mapGetters } from 'vuex'

const initCpa = ($this) => ({
  cpa: null,
  crg: null,
  crgWeek: null,
  startDate: $this?.$moment()
      .startOf('week')
      .format('YYYY-MM-DD'),
  endDate: null,
  lateFTDContract: 'ADJUSTED_CYCLE',
  maxFtdLateDays: null
})

export default {
  name: 'AffiliateCPAModal',
  components: { CalendarPicker },
  props: {
    affiliateId: {
      required: true,
      type: String
    },
  },
  data: () => ({
    newModal: {
      id: 'new-modal',
      content: '',
      active: false
    },
    newCpa: initCpa(),
    busy: false,
  }),
  computed: {
    affiliateLateFTDContractOptions() {
      let options = this.$t('affiliateLateFTDContract')
      return Object.values(options || {})
    },
    editing() {
      return this.newCpa?.id != null
    },
    canNotSave() {
      let newCpa = this.newCpa
      return newCpa.cpa == null || newCpa.crg == null || newCpa.crgWeek == null
          || newCpa.startDate == null || (newCpa.lateFTDContract != null && newCpa.maxFtdLateDays == null)
    },
    isMaxFtdLateDaysNotRequired() {
      return this.newCpa?.lateFTDContract == null || this.newCpa?.lateFTDContract === 'NO_PAYMENT'
    },
  },
  methods: {
    ...mapActions('affiliate', ['createCpaAffiliate', 'editCpaAffiliate']),
    show(item) {
      this.newCpa = Object.assign(initCpa(this), item)
      this.newModal.active = true
    },
    async saveCpa(confirm) {
      let $this = this
      this.busy = true
      let operation = this.editing ?
          this.editCpaAffiliate({ id: this.affiliateId, cpa: this.newCpa, cpaId: this.newCpa.id, confirm }) :
          this.createCpaAffiliate({ id: this.affiliateId, cpa: this.newCpa, confirm })
      operation.then(response => {
        this.showSuccessNotification($this.$t('globalMessages.updateDataSuccess', { system: $this.$t('menu.affiliates') }))
        this.refreshTables()
        this.$emit('input', this.affiliate)
      })
      operation.catch(err => {
        if (err != null && err.message != null) {
          return this.askForConfirmation(err.message)
        }
        this.showErrorNotification(this.$t('globalMessages.fetchDataError', { system: this.$t('menu.affiliates') }), err.response.data.error)
      })
      operation.finally(()=>{
        $this.busy = false
      })

    },
    askForConfirmation(message) {
      let $this = this
      this.$bvModal.msgBoxConfirm(this.$t(`errorDefinition.error.${message}`), {
        title: this.$t('confirmation'),
        size: 'md', buttonSize: 'sm', centered: true, hideHeaderClose: false,
        okVariant: 'danger', okTitle: this.$t('operations.yes'),
        cancelTitle: this.$t('operations.no'),
        footerClass: 'p-2',
      })
          .then(value => {
            if (value) $this.saveCpa(true)
          })
          .catch(err => {
            // An error occurred
          })
    },
    resetInfoModal() {
      this.newCpa = initCpa(this)
    }
  }
}
</script>


<style scoped>

</style>